// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__b9ee1","obliqueLineWrap":"membershipbadge_obliqueLineWrap__30ATQ","obliqueLine":"membershipbadge_obliqueLine__3MzbB"};